/**
 * Where an account belongs when it has not asked for anywhere in particular:
 * the brand link in the frame, and the page signing in lands on.
 *
 * One function rather than a decision made twice, because the two have to
 * agree — dropping somebody on a page their own navigation does not list is
 * worse than either choice alone.
 *
 * A consultant has one room and everything they do happens in it. The desk gets
 * today's sessions rather than the dashboard — the dashboard is a glance at how
 * the clinic is doing, and reception opens the app to work rather than to look.
 * A superadmin who has not chosen a clinic to stand in has exactly one page
 * that is theirs.
 */
export function home(role: string | undefined, inClinic: boolean): string {
  if (role === "DOCTOR") return "/chamber";
  return inClinic ? "/sessions" : "/onboard";
}
